import { render, staticRenderFns } from "./financeiro-agrupamentos.vue?vue&type=template&id=6d64e6df"
import script from "./financeiro-agrupamentos.vue?vue&type=script&lang=ts"
export * from "./financeiro-agrupamentos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports